import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { IncompleteStepsModal } from "../../../components/incomplete-steps-modal";
import { UploadDocumentType } from "../../../types";
import { SusaDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const SusaDocumentUploadPage = () => {
  const intl = useIntl();

  const { primaryAction, secondaryAction, applicationSubmit, documentError } = useDocumentNavigationActions({
    forType: UploadDocumentType.SUSA,
  });

  return (
    <>
      <IncompleteStepsModal {...applicationSubmit} />
      <OnboardingLayout
        variant="wide"
        title={intl.formatMessage(MESSAGES.susaTitle)}
        actions={{ primary: primaryAction, secondary: secondaryAction }}
      >
        <Flex maxWidth="550px">
          <SusaDocumentUpload error={documentError} />
        </Flex>
      </OnboardingLayout>
    </>
  );
};
